import { activitiesReducer } from './activities/reducer';
import { apiRequestsReducer } from './api-requests/reducer';
import { dictionariesReducer } from './dictionaries/reducer';
import { globalReducer } from './global/reducer';
import { opportunitiesReducer } from './opportunities/reducer';
import { orderMetricsReducer, ordersReducer } from './orders/reducer';
import { productsReducer } from './products/reducer';
import {
  proposalMetricsDatesReducer,
  proposalMetricsReducer,
  proposalsReducer,
} from './proposals/reducer';
import { salesRepReducer } from './sales-rep/reducer';
import { shippingAddressesReducer } from './shipping-addreses/reducer';
import { surveyReducer } from './site-survey/reducer';
import { tasksReducer } from './tasks/reducer';
import { uploadsQueueReducer } from './uploads-queue/reducer';
import { userReducer } from './user/reducer';

export const reducers = {
  activities: activitiesReducer,
  apiRequests: apiRequestsReducer,
  dictionaries: dictionariesReducer,
  global: globalReducer,
  opportunities: opportunitiesReducer,
  orders: ordersReducer,
  orderMetrics: orderMetricsReducer,
  products: productsReducer,
  proposal: proposalsReducer,
  proposalMetrics: proposalMetricsReducer,
  proposalMetricsDates: proposalMetricsDatesReducer,
  salesRep: salesRepReducer,
  shippingAddresses: shippingAddressesReducer,
  uploadsQueue: uploadsQueueReducer,
  user: userReducer,
  survey: surveyReducer,
  openTasks: tasksReducer,
};
